<template>
  <div>
    <h3 v-if="mw && mw.title" class="mb-4">{{ mw.title }}</h3>
    <template v-if="mw.content">
      <p v-for="(t, i) in mw.content" :key="i" class="mb-2">{{ t }}</p>
    </template>
    <portal to="v-wizard-action" v-if="loaded">
      <v-btn @click="$emit(`next`, -1)" class="mr-2">Назад</v-btn>
      <v-btn @click="submit">Завершить</v-btn>
    </portal>
  </div>
</template>

<script>
import { getForm, submitForm, removeEl, genModel, getAccess } from "@/components/mixings";

export default {
  components: {},
  mixins: [getForm, submitForm, removeEl, genModel, getAccess],
  props: {
    wizard: {
      type: Object,
      default: () => {},
    },
    mw: {
      type: Object,
      default: () => {},
    },
    defaults: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      showDocument: false,
      m: this.$store.getters["config/get"].models.contracts,
      model1: [],
      isNew: 0,
      model: [],
      id: null,
      loaded: false,
      type: 1,
      wizardData: {},
    };
  },
  computed: {
    readonly() {
      return false;
      return !!this.wizard?.contract?.template_id;
    },
    api() {
      return this.m.api;
    },
    config() {
      return {
        note: " Договор с клиентом",
        fields:
          "data.prepay,object_id,type_contract_number,contract_number,name,contract_type,contract_date,contract_end,side_1_vendor_id,side_2_client_id,comments,status,docs,filesRemove,filesAdd,template_id",
        fieldsRO: "contract_type,side_2_client_id,object_id",
        fieldsForm:
          "type_contract_number#4,contract_number#8,name,contract_type#8,data.prepay#4,object_id,contract_date#6,contract_end#6,side_1_vendor_id,side_2_client_id,comments,docs",
        fieldsReplace: {
          contract_type: { name: "contract_type", default: 1, _type: "join" },
          side_2_client_id: { name: "side_2_client_id", default: this.wizard.client.clientId, validator: ["req"], _type: "join" },
          object_id: { name: "object_id", default: this.wizard.object.objectId, validator: ["req"], _type: "join" },
        },
      };

      return this.mw?.contract?.config || {}; //.wizardContract;
    },
  },
  created() {
    this.init();
  },
  watch: {},
  methods: {
    waitForEvent(eventName, payload) {
      return new Promise(resolve => {
        this.$emit(eventName, payload, resolve);
      });
    },
    async init() {
      this.loaded = !true;
      this.id = this.wizard?.contract?.id;

      this.updateData(this.id);
      //if (!this.id) this.afterFetchData();
    },
    updateData() {
      this.applyData(this.wizard?.contract || {});
      this.afterFetchData();
    },

    afterFetchData(r) {
      this.wizardData = Object.assign({}, this.wizard.contract);
      this.calcModel();

      this.loaded = true;
    },
    calcModel(t) {
      let config = this.config;
      let model = this.calcModelConfig(config, this.m);

      this.fillFormFromModel(model);
      this.model = model;

      return model;
    },

    async post(data, api, silent = false) {
      this.loading = true;
      try {
        this.wizardData = Object.assign({}, data);
        const result = await this.waitForEvent("save", this.wizardData);
        if (!result.ok) throw result;
        this.afterSave(data, status);
      } catch (error) {
        this.$root.$emit("show-info", {
          type: "error",
          text: "Ошибка при сохранении " + error?.message,
        });
        this.loading = false;
        return;
      }
    },
    async afterSave(data, status) {
      this.isChanged = false;
    },
  },
};
</script>
